export default __webpack_public_path__ + "static/media/match-invoices.ab1c834e.png";